export function validateEmail(email) {
  if (!email || !email.includes("@")) {
    return "Invalid email format.";
  }

  const allowedDomains = [
    "gmail.com",
    "yahoo.com",
    "outlook.com",
    "hotmail.com",
    "aol.com",
    "icloud.com",
    "protonmail.com",
    "zoho.com",
    "gmx.com",
    "mail.com"
  ];

  const parts = email.toLowerCase().split("@");
  if (parts.length !== 2 || !parts[1]) {
    return "Invalid email format.";
  }

  const domain = parts[1];

  if (!allowedDomains.includes(domain)) {
    return `Please use an email address with one of the following approved domains: ${allowedDomains.join(
      ", "
    )}.`;
  }

  return "";
}
